import { INVENTORY_CHARTS_KEYS, MAP_LABEL_TO_CHARTS } from "./main-report.entity";

export const DEFAULT_STACKED_COLUMN_CHART_REPORT = [
  {
    name: "Fugitive",
    data: [0],
    group: "apexcharts-axis-0",
  },
  {
    name: "Combustion",
    data: [0],
    group: "apexcharts-axis-0",
  },
  {
    name: "Flare",
    data: [0],
    group: "apexcharts-axis-0",
  },
  {
    name: MAP_LABEL_TO_CHARTS["Transportation & Marketing" as INVENTORY_CHARTS_KEYS],
    data: [0],
    group: "apexcharts-axis-0",
  },
  {
    name: MAP_LABEL_TO_CHARTS["Storage Tank" as INVENTORY_CHARTS_KEYS],
    data: [0],
    group: "apexcharts-axis-0",
  },
  {
    name: MAP_LABEL_TO_CHARTS["Wastewater Treatment Plant" as INVENTORY_CHARTS_KEYS],
    data: [0],
    group: "apexcharts-axis-0",
  },
];
